import React from 'react'

import CalendarHandler from './CalendarHandler'
import CalendarNavigation from './CalendarNavigation'
import DayView from './DayView'
import MonthView from './MonthView'
import Separator from '../helpers/Separator'
import WeekView from './WeekView'

const Calendar = ({ hideNavigation, children, ...props }) => {
  return (
    <CalendarHandler {...props}>
      {children}
      {!hideNavigation && <CalendarNavigation />}
      <Separator weight={4} />

      <MonthView />
      <WeekView />
      <DayView />
    </CalendarHandler>
  )
}

export default Calendar
